import React, { Component } from 'react';
import '../CSS/newRecord.css';
import Sidemenu from './Navbar/Sidemenu';
import GenericNavbar from './Navbar/GenericNavbar';

class UserList extends Component{
    constructor(props){
        super(props)
        this.state = {
            user:'',
            tableData:[]
        }
    }
    componentDidMount(){
        var user = localStorage.getItem("user");
        user = JSON.parse(user);
        if(user){
            console.log(user)
			this.setState({user:user});
		}
        var user = localStorage.getItem("user");
        user = JSON.parse(user);
        if(user){
			this.setState({user:user});
		}
        fetch(`http://52.60.64.107/api/orginatorx-new/user-list.php?method=getall`)
        .then(response => response.json())
        .then(data => {
            this.setState({tableData: data.result});
            console.log(this.state.tableData)
        }); 
    }

    render(){
        return(
            <div className = "">
                <GenericNavbar/>
                {this.state.accounts &&
                <p className='wal-address'>{this.state.accounts[0] } </p>
                }
                <div className="container-fluid bg-black">
                <div className="row">
                    <Sidemenu />
                   
                    <div className="col s10">
                        <div className="card reportCard">
                            <div className="card-title cardTitle2">
                                <h4 className = "cardTitle">List</h4>
                            </div>
                            <div className="card-content">
                            <table className='highlight'>
                            <thead>
                                <tr>
                                    <th>Sl</th>
                                    <th>User name</th>
                                    <th>Email</th>
                                    <th>Password</th>
                                    <th>Date</th>
                                </tr>
                            </thead>
                            {this.state.tableData.length >0 &&
                            <tbody>
                                {this.state.tableData.map((user, key) => {
                                    return <tr key={key}>
                                    <td>{key+1} </td>
                                    <td>{ user.f_name } { user.l_name } </td>
                                    <td>{ user.email } </td>
                                    <td>{ user.password } </td>
                                    <td>{ user.create_date } </td>
                                </tr>;
                                })}
                            </tbody>
                            }
                        </table>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        )
    }
}

export default UserList;
